import { Bot, Plus, Send, Sparkles } from "lucide-react";
import { FormEvent, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Button, PageHeader, cn } from "../components/ui";
import { api, errMsg } from "../lib/api";
import { Md, SUGGEST, useAiChat } from "../lib/aiChat";

export default function AiChat() {
  const [sessions, setSessions] = useState<any[]>([]);
  const { sid, setSid, msgs, setMsgs, busy, ask, fresh } = useAiChat();
  const [q, setQ] = useState("");
  const bottom = useRef<HTMLDivElement>(null);

  const loadSessions = () => api.get("/ai/chat/sessions").then((r) => setSessions(r.data)).catch(() => {});
  useEffect(() => { loadSessions(); }, []);
  useEffect(() => { bottom.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);
  const openSession = (s: string) => { setSid(s); api.get(`/ai/chat/${s}`).then((r) => setMsgs(r.data.map((m: any) => ({ role: m.role, content: m.content })))).catch((e) => toast.error(errMsg(e))); };
  const send = (text: string) => { setQ(""); ask(text, loadSessions); };
  const submit = (e: FormEvent) => { e.preventDefault(); send(q); };

  return (
    <div data-testid="ai-chat-page" className="flex flex-col h-[calc(100vh-7rem)]">
      <PageHeader title="Asisten AI" subtitle="Tanya data koperasi dengan bahasa sehari-hari · hanya membaca data, tidak mengubah apa pun" actions={<Button variant="outline" onClick={fresh} data-testid="ai-chat-new"><Plus className="h-4 w-4" /> Percakapan baru</Button>} />
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-4 min-h-0">
        <aside className="hidden lg:block card-surface p-3 overflow-y-auto" data-testid="ai-chat-sessions">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2">Riwayat</p>
          {sessions.length === 0 && <p className="text-xs text-muted-foreground">Belum ada percakapan.</p>}
          {sessions.map((s) => <button key={s.session_id} onClick={() => openSession(s.session_id)} data-testid={`ai-chat-session-${s.session_id}`} className={cn("w-full text-left text-xs rounded-md px-2 py-1.5 truncate hover:bg-muted", s.session_id === sid && "bg-muted font-semibold")}>{s.title}</button>)}
        </aside>
        <section className="card-surface flex flex-col min-h-0">
          <div className="flex-1 overflow-y-auto p-4 space-y-4" data-testid="ai-chat-messages">
            {msgs.length === 0 && (
              <div className="h-full grid place-items-center">
                <div className="text-center max-w-lg">
                  <Bot className="h-10 w-10 mx-auto text-primary" />
                  <p className="mt-3 font-display font-bold">Apa yang ingin Anda ketahui?</p>
                  <div className="mt-4 flex flex-wrap justify-center gap-2">{SUGGEST.map((s) => <button key={s} onClick={() => send(s)} data-testid="ai-chat-suggest" className="text-xs rounded-full border px-3 py-1.5 hover:bg-muted transition-colors inline-flex items-center gap-1"><Sparkles className="h-3 w-3" /> {s}</button>)}</div>
                </div>
              </div>
            )}
            {msgs.map((m, i) => (
              <div key={i} className={cn("flex", m.role === "user" ? "justify-end" : "justify-start")} data-testid={`ai-chat-msg-${m.role}`}>
                <div className={cn("max-w-[85%] rounded-2xl px-4 py-2.5", m.role === "user" ? "bg-primary text-primary-foreground text-sm" : "bg-muted")}>
                  {m.role === "user" ? m.content : m.content ? <Md text={m.content} /> : <span className="text-xs text-muted-foreground animate-pulse">Menganalisis data…</span>}
                </div>
              </div>
            ))}
            <div ref={bottom} />
          </div>
          <form onSubmit={submit} className="border-t p-3 flex gap-2">
            <input className="yt-input flex-1" placeholder="Tulis pertanyaan… (mis. siapa yang menunggak di unit Karawang?)" value={q} onChange={(e) => setQ(e.target.value)} disabled={busy} data-testid="ai-chat-input" />
            <Button type="submit" disabled={busy || !q.trim()} data-testid="ai-chat-send"><Send className="h-4 w-4" /></Button>
          </form>
        </section>
      </div>
    </div>
  );
}
